import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { useConfigurationContext } from "../root/ConfigurationContext";
import { findStageLabel, getStageTone } from "./sponsoringUtils";

/**
 * Stage badge: funnel stages are neutral, active stages green, closed
 * stages (ended / declined) muted.
 */
export const StageBadge = ({
  stage,
  className,
}: {
  stage: string;
  className?: string;
}) => {
  const config = useConfigurationContext();
  const label = findStageLabel(config.sponsoringStages, stage) ?? stage;
  const tone = getStageTone(stage, config);

  return (
    <Badge
      variant={tone === "funnel" ? "secondary" : "outline"}
      data-tone={tone}
      className={cn(
        "whitespace-nowrap",
        tone === "active" && "border-transparent bg-green-100 text-green-800",
        tone === "closed" &&
          "border-transparent bg-muted text-muted-foreground",
        className,
      )}
    >
      {label}
    </Badge>
  );
};
